
import {filesApi} from './files' 


export const businessdocdelete = filesApi.injectEndpoints({
  endpoints: (builder) => ({
    deleteBusinessDocument: builder.mutation({
      query: ({businessId, documentKey}) => ({
        url: 's3/user/docs/delete',
        method: 'DELETE',
        body: {businessId, documentKey}
      }),
      // Optionally, you can invalidate other queries when a document is deleted
      // This will force a refresh of any affected data
      invalidatesTags: ['BusinessDocuments']
    }),
    

  }),
  overrideExisting: false,
})

export const { useDeleteBusinessDocumentMutation } = businessdocdelete